import { ListPlus } from "lucide-react";
import { usePlaylists } from "../contexts/PlaylistsContext";

/** Bouton « + Ajouter à une playlist » (icône seule ou pastille avec texte). */
export default function AddToPlaylistButton({ track, variant = "icon", size = "md", className = "", testid }) {
    const { openPicker } = usePlaylists();
    if (!track) return null;
    const onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPicker(track);
    };
    if (variant === "pill") {
        return (
            <button
                type="button"
                onClick={onClick}
                className={`inline-flex items-center gap-1.5 px-3 py-2 rounded-full text-sm border border-[#262626] text-[#A8A8A8] hover:text-[#00d97e] hover:border-[#00d97e]/40 transition-colors ${className}`}
                data-testid={testid || `add-to-playlist-pill-${track.id}`}
            >
                <ListPlus className="w-4 h-4" /> Ajouter à une playlist
            </button>
        );
    }
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${size === "sm" ? "w-7 h-7" : "w-9 h-9"} rounded-full inline-flex items-center justify-center text-[#A8A8A8] hover:text-[#00d97e] hover:bg-[#1c1c1c] transition-all ${className}`}
            aria-label="Ajouter à une playlist"
            title="Ajouter à une playlist"
            data-testid={testid || `add-to-playlist-${track.id}`}
        >
            <ListPlus className={size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4"} />
        </button>
    );
}
